export const DIMENSION = {
  PADDING_DEFAULT: 20,
  MARGIN_DEFAULT: 20,
}